import gsap, { Power3 } from "gsap";

import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import { GetBy } from '../_app/cuchillo/core/Element';
import InfiniteScroll from '../_app/cuchillo/scroll/InfiniteScroll';
import InfiniteScroll__Item from '../_app/cuchillo/scroll/InfiniteScroll__Item';
import { isMobile } from "../_app/cuchillo/core/Basics";

class ScrollItem__WidgetReel extends VScroll_Item {
  thumb;
  inactivityTimeout = null;
  isVisible = true;

  _calls = {
    mouseMove: () => this.onMouseMove(),
    mouseOut: () => { },
    showThumb: () => this.showThumb(),
    hideThumb: () => this.hideThumb()
  }

  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================
  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);

    this.thumb = GetBy.selector('[data-progress]', __link)[0];
    gsap.set(this.thumb, { scaleX: 0 });
    this.thumb.style.transformOrigin = 'center left';

    this.addEventListeners();

    this.onShow = () => {
      gsap.to(this.thumb, { opacity: 1 });
      gsap.to(this.thumb, {
        scaleX: '100%',
        ease: Power3.easeOut,
        duration: .5
      });

      gsap.delayedCall(2, () => {
        this.hideThumb();
      });
    };

    this.onHide = () => {
      this.thumb.style.transformOrigin = 'center right';

      gsap.to(this.thumb, {
        scaleX: 0,
        ease: Power3.easeOut,
        duration: .5
      });

      this.removeEventListeners();
    };
  }
  onMouseMove() {
    this.timestamp = Date.now();

    if (!this.isVisible) {
      this.showThumb();
    }

    if (this.inactivityTimeout) {
      clearTimeout(this.inactivityTimeout);
    }

    this.inactivityTimeout = setTimeout(() => {
      const now = Date.now();
      if (now - this.timestamp >= 1500) {
        this.hideThumb();
      }
    }, 2000);
  }

  showThumb() {
    this.isVisible = true;
    gsap.set(this.thumb, { opacity: 1 });
  }

  hideThumb() {
    this.isVisible = false;
    gsap.to(this.thumb, { opacity: 0, duration: .2 });
  }

  addEventListeners() {
    if (!isMobile) {
      this.item.addEventListener('mousemove', this._calls.mouseMove);
    }
  }

  removeEventListeners() {
    if (!isMobile) {
      this.item.removeEventListener('mousemove', this._calls.mouseMove);
    }
  }
}

Scroll._registerClass('WidgetReel', ScrollItem__WidgetReel);
